
	import { defineComponent } from 'vue'
	import { iNews } from './NewsManagement'
	import Avatar from 'primevue/avatar'
	import { AxiosResponse } from 'axios'
	import FabButton from '@/components/UI/KnFabButton.vue'
	import Listbox from 'primevue/listbox'
	import newsManagementDescriptor from './NewsManagementDescriptor.json'
	import WEB_SOCKET from '@/services/webSocket.js'

	export default defineComponent({
		name: 'news-management',
		components: {
			Avatar,
			FabButton,
			Listbox
		},
		data() {
			return {
				newsManagementDescriptor,
				newsList: [] as iNews[],
				touched: false,
				loading: false
			}
		},
		async created() {
			await this.loadAllNews()
		},
		methods: {
			async loadAllNews() {
				this.loading = true
				this.newsList = []
				await this.$http
					.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '2.0/news')
					.then((response: AxiosResponse<any>) => {
						response.data.map((news: iNews) => {
							this.newsList.push({ ...news, newsType: this.setNewsType(news.type) })
						})
					})
					.finally(() => (this.loading = false))
			},
			showForm(event: any) {
				const path = event.value ? `/news-management/${event.value.id}` : '/news-management/new-news'
				if (!this.touched) {
					this.$router.push(path)
				} else {
					this.$confirm.require({
						message: this.$t('common.toast.unsavedChangesMessage'),
						header: this.$t('common.toast.unsavedChangesHeader'),
						icon: 'pi pi-exclamation-triangle',
						accept: () => {
							this.touched = false
							this.$router.push(path)
						}
					})
				}
			},
			deleteNewsConfirm(news) {
				this.$confirm.require({
					message: this.$t('common.toast.deleteMessage'),
					header: this.$t('common.toast.deleteTitle'),
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.touched = false
						this.deleteNews(news)
					}
				})
			},
			async deleteNews(news) {
				await this.$http.delete(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '2.0/news/' + news.id).then(() => {
					this.$store.commit('setInfo', {
						title: this.$t('common.toast.deleteTitle'),
						msg: this.$t('common.toast.deleteSuccess')
					})
					WEB_SOCKET.send(JSON.stringify(news))
					this.$router.push('/news-management')
					this.loadAllNews()
				})
			},
			pageReload() {
				this.touched = false
				this.loadAllNews()
			},
			setNewsType(type: number) {
				switch (type) {
					case 1:
						return 'News'
					case 2:
						return 'Notification'
					case 3:
						return 'Warning'
				}
			}
		}
	})
